import styled, { css } from "styled-components";

type ButtonProps = {
  isSelected: boolean;
};

export const Container = styled.div<ButtonProps>`
  ${({ theme, isSelected }) => css`
    width: 100%;
    border-radius: 10px;
    background-color: ${theme.colors.background_light};

    border: 1px solid ${isSelected ? theme.colors.primary : "transparent"};
    display: flex;
    justify-content: space-between;
  `}
`;

export const Button = styled.button`
  width: 100%;
  padding: 15px;

  display: flex;
  align-items: center;
`;

export const CheckBox = styled.div`
  ${({ theme }) => css`
    width: 15px;
    height: 15px;
    margin-right: 15px;
    border: 1px solid ${theme.colors.text};
    border-radius: 5px;

    display: flex;
    justify-content: center;
    align-items: center;
  `}
`;

export const DetailsContainer = styled.div`
  ${({ theme }) => css`
    width: 100%;
    display: flex;
    justify-content: space-between;
    min-height: 40px;
  `}
`;

export const Details = styled.a`
  ${({ theme }) => css`
    font-size: 12px;
    font-weight: 500;
    color: ${theme.colors.primary};
    border-bottom: solid 1px ${theme.colors.primary};
    position: absolute;
    right: 0;
    bottom: 0;
  `}
`;

export const DetailsObservations = styled.a`
  ${({ theme }) => css`
    border-bottom: solid 1px ${theme.colors.text_light_87};
  `}
`;

export const CheckedFilled = styled.div<ButtonProps>`
  ${({ theme, isSelected }) => css`
    width: 7px;
    height: 7px;
    background-color: ${isSelected ? theme.colors.primary : "transparent"};
    border-radius: 2px;
  `}
`;

export const Content = styled.button`
  width: 100%;
  display: flex;
  position: relative;
`;

export const WrapperDetail = styled.button`
  width: 100%;
  display: flex;
  gap: 10px;

  img {
    width: 65px;
    height: 65px;
    border-radius: 10px;
  }
`;

export const WrapperInfo = styled.div`
  width: 100%;
  display: flex;
  text-align: left;
  flex-direction: column;
  margin: auto 0;
`;

interface TitleProps {
  spacingPrice?: boolean;
}

export const Title = styled.p<TitleProps>`
  ${({ theme, spacingPrice }) => css`
    display: flex;
    justify-content: space-between;
    font-weight: 600;
    color: white;

    margin-bottom: 5px;
    font-size: 12px;
  `}
`;

export const Label = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.text_light_60};
    font-size: 12px;
    margin-bottom: 5px;
  `}
`;

export const DescriptionLabel = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.text_light_87};
    font-size: 12px;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    color: ${theme.colors.text};
    margin-bottom: 4px;
  `}
`;

export const ObservationButton = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: 12px;
    text-decoration: underline;
    margin-top: 4px;
  `}
`;

export const WrapperPrice = styled.button`
  ${({ theme }) => css`
    p {
      font-size: ${theme.font.sizes.xsmall};
      color: ${theme.colors.title};
    }
  `}
`;

export const WrapperActions = styled.div`
  ${({ theme }) => css`
    width: 10%;
    max-width: 70px;
    min-height: 110px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    background-color: ${theme.colors.background_light};

    display: flex;
    flex-direction: column;
  `}
`;

export const Checklist = styled.div`
  ${({ theme }) => css`
    padding-top: 3px;
    p {
      color: ${theme.colors.primary};
      letter-spacing: 0.26px;
      line-height: 16px;
      font-size: ${theme.font.sizes.xsmall};
      text-align: left;
    }
  `}
`;
